import { getTranslatedGenre, formatRelativeTimeCompact, getTranslatedProjectStatus } from '../../utils/i18nHelpers';

export const COMMUNITY_GENRES = [
  'Fiction',
  'Fantasy',
  'Sci-Fi',
  'Mystery',
  'Romance',
  'Business',
  'Self-Help',
  'Memoir/Bio',
  'History',
  'Science/Tech',
];

export const COMMUNITY_POST_TYPES = [
  { value: 'text', label: 'Text update' },
  { value: 'excerpt', label: 'Excerpt' },
  { value: 'poll', label: 'Poll' },
];

export function getCommunityTabs(t) {
  return [
    { to: '/projects/community/following', key: 'following', label: `👥 ${t('community.tabs.following')}` },
    { to: '/projects/community', key: 'home', label: `🧭 ${t('community.tabs.discover')}` },
    { to: '/projects/community/soundbites', key: 'soundbites', label: `🎧 ${t('community.tabs.soundbites')}` },
    { to: '/projects/community/saved', key: 'saved', label: `🔖 ${t('community.tabs.saved')}` },
  ];
}

export function formatRelativeTime(t, timestamp) {
  return formatRelativeTimeCompact(t, timestamp);
}

export function getGenreOptions(t) {
  return COMMUNITY_GENRES.map((genre) => ({
    value: genre,
    label: getTranslatedGenre(t, genre),
  }));
}

export function getGenreDisplayLabel(t, genre) {
  return getTranslatedGenre(t, genre);
}

export function getProjectStageDisplayLabel(t, stage) {
  return getTranslatedProjectStatus(t, stage);
}

export function parseTagInput(value, max = 6) {
  const seen = new Set();
  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
    .filter((item) => {
      const key = item.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, max);
}

export function makeExcerptPreview(content, start, end, fallbackLength = 280) {
  const source = (content || '').trim();
  if (!source) return '';
  if (typeof start === 'number' && typeof end === 'number' && end > start) {
    return source.slice(start, end).trim();
  }
  return source.slice(0, fallbackLength).trim();
}

export function getProfileDefaults(currentUser) {
  const user = currentUser?.user;
  const profile = currentUser?.profile;
  return {
    displayName: profile?.displayName || user?.name || user?.email?.split('@')[0] || '',
    handle: profile?.handle || user?.name || user?.email?.split('@')[0] || '',
    bio: profile?.bio || '',
    genreTags: Array.isArray(profile?.genreTags) ? profile.genreTags : [],
    experienceLevel: profile?.experienceLevel || '',
    favoriteAuthor: profile?.favoriteAuthor || '',
  };
}
